import { Component, EventEmitter, Output, OnInit, AfterViewInit, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { GridApi, CellEditingStoppedEvent, ValueFormatterParams } from 'ag-grid-community';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ContactTypeEditorComponent } from '../contact-type-editor/contact-type-editor.component'
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ContactModalComponent } from '../contact-modal/contact-modal.component';
import * as SelectList from '../select_option';
import { MatTableDataSource } from '@angular/material/table';
import { ContactDocumentInfo } from '../../work-orders/work-order-details/work-order.interfaces';
import { DocumentModalComponent } from '../../work-orders/work-order-details/document-modal/document-modal.component';

@Component({
  selector: 'app-contact-full-details',
  templateUrl: './contact-full-details.component.html',
  styleUrls: ['./contact-full-details.component.scss']
})

export class ContactFullDetailsComponent implements OnInit {
  public params: any;
  private gridApi!: GridApi;

  // UI state
  isLoading = false;
  isDraggingOverDocument = false;
  contact_organization: string = '';

  // forms for editing/creating new records
  generalInfoForm!: FormGroup;  
  accountingForm!: FormGroup;
  operationsForm!: FormGroup;
  appointmentContactForm!: FormGroup;
  wisbForm!: FormGroup;
  insuranceForm!: FormGroup;
  salesProfileForm!: FormGroup;

  // initialize objects to store details of contact details
  address_details: Array<{ [key: string]: string | number | object | boolean }> = [];
  subcontact_details: Array<{ [key: string]: string | number | object | boolean }> = [];
  url_details: Array<{ [key: string]: string | number | object | boolean }> = [];
  type_details: Array<{ [key: string]: string | number | object | boolean }> = [];
  email_details: Array<{ [key: string]: string | number | object | boolean }> = [];  
  note_details: Array<{ [key: string]: string | number | object | boolean }> = [];
  notification_details: Array<{ [key: string]: string | number | object | boolean }> = [];  
  general_info: any = [{
    "contact_uuid": "",
    "contact_category": "",
    "contact_email": "",
    "contact_name_family": "",
    "contact_name_given": "",
    "contact_name_middle": "",
    "contact_name_prefix": "",
    "contact_name_suffix": "",
    "contact_nickname": "",
    "contact_note": "",
    "contact_organization": "",
    "contact_role": "",
    "contact_title": "",
    "contact_url": "",
    "contact_parent_uuid": "",
    "customer_contact_uuid": "",
    "insurance_agent_uuid": "",
    "payment_processor_uuid": "",
    "carrier_contact_uuid": "",
    "us_dot_no": "",
    "pool_id": "",
    "pool_location": "",
    "drop_trailer_party": "",
    "active": true
  }];  
  contact_profile: any = [{
        "contact_profile_uuid": '',
        "contact_uuid": '',
        "loading_dock": '',
        "tailgate": '',
        "ground_level": '',
        "truck_space": '',
        "straight_truck": '',
        "high_cost": '',
        "convention_center": '',
        "pop_up": '',
        "residential": '',
        "elevator_inside": '',
        "delivery_inside": '',
        "hallway_corner": '',
        "to_friday": '',
        "to_saturday": '',
        "to_thursday": '',
        "seven_days": '',
        "monday_only": '',
        "tuesday_only": '',
        "wednesday_only": '',
        "thursday_only": '',
        "friday_only": '',
        "appointments": '',
        "appointment_start": '',
        "appointment_end": '',
        "appointment_day": '',
        "opening_time": '',
        "closing_time": '',
        "after_hours": '',
        "access_loading": '',        
        "interprovincial": '',
        "intraprovincial": '',
        "canada_us_border": '',
        "interstate": '',
        "intrastate": '',
        "operation_profile_province": '',
        "operation_profile_state": '',
        "mexico_border": '',
        "canada_west": '',
        "canada_central": '',
        "canada_east": '',
        "usa_new_england": '',
        "usa_mid_atlantic": '',
        "usa_great_lakes": '',
        "usa_mid_west": '',
        "usa_south_atlantic": '',
        "usa_southeast": '',
        "usa_south_central": '',
        "usa_mountain": '',
        "usa_pacific": '',
        "usa_far_pacific": '',
        "use_csa": '',
        "use_fast": '',
        "use_ace": '',
        "use_aci": '',
        "use_ct_pat": '',
        "use_can_bond": '',
        "use_us_bond": '',
        "use_hazmat": '',
        "protect_freezing": '',
        "heated": '',
        "refrigeration": '',
        "use_food_grade": '',
        "bol_shipping": '',
        "bol_invoice": '',
        "pod_invoice": '',
        "purchase_order_number_invoice": '',
        "rate_quote_copy": '',
        "pick_up_reference_number": '',
        "delivery_reference_number": '',                
  }];
  contact_profile_appointment_contacts: any = [{
    "contact_profile_appointment_contact_uuid": "",
    "name": "",
    "email": "",
    "phone_number": "",
    "mobile_number": "",
  }];

  accounting_profile: any = {};
  wisb_forms: any = [{
    "wisb_form_uuid": "",
    "legal_name": "",
    "business_name": "",
    "us_taxpayer_id_no": "",
    "wisb_account_no": "",
    "other": "",
    "individual_proprietor": "",
    "c_corporation": "",
    "s_corportation": "",
    "partnership": "",
    "trust_estate": "",           
    "llc_llp": "",    
    "exempt_payee": "",    
    "address_street": "",    
    "address_extended": "",    
    "address_locality": "",    
    "address_region": "",    
    "address_country": "",    
    "address_postal_code": "",    
    "wisb_certificate_no": "",    
    "wisb_certificate_valid": "",                     
  }];

  insurance_form: any = [{
    "insurance_form_uuid": "",
    "policy_no": "",
    "gl_limit": '',
    "gl_expires": "",
    "auto_expires": "",
    "auto_limit": "",
    "cargo_expires": "",
    "cargo_limit": "",
    "wc_expires": "",
    "insurance_agent_information": "",
    "agent_phone": "",
    "agent_fax": "",       
    "description": "",   
    "agent_contact_uuid": "",   
    "agent_name": "",   
    "previous_theft_claim": "",   
    "computers": "",   
    "electronics": "",   
    "liguor": "",   
    "theft": "",   
    "unsecure_yard": "",   
    "other_exclusion": "",                        
    "agent_email": "",  
    "licensing": "",  
  }];

  sales_profile: any = [{
    "sales_profile_uuid": "",
    "sales_status": "",
    "last_action": "",
    "username": "",
    "cross_border": "",
    "us_only": "",
    "canada_only": "",
    "warehouse_distribution": "",
    "specialized_services": "",
    "tradeshow_freight": "",       
    "trailer_build": "",   
    "action_type": '',
    "drip_status": "",
    "sales_potential": "",
    "sales_manager": "",
    "current_provider": "",
    "sales_evaluation": "",
  }];
  service_rates: Array<{ [key: string]: string | number | object | boolean }> = [];
  contact_profile_default_services: Array<{ [key: string]: string | number | object | boolean }> = [];
  displayedColumns: string[] = ['file_name', 'file_type', 'actions'];

  // initialize UUIDs for each different contact detail tab
    // Lading UUID from route
  contact_uuid: string | null = null;
  accounting_profile_uuid: string | null = null;
  contact_profile_uuid: string | null = null;
  appointment_contact_uuid: string | null = null;
  wisb_form_uuid:  string | null = null; 
  insurance_form_uuid:  string | null = null; 
  sales_profile_uuid:  string | null = null; 

  // booleans to test if contact needs to create a new profile or update an existing one
  addressExists: boolean = false
  phoneExists: boolean = false
  typeExists: boolean = false
  urlExists: Boolean = false
  emailExists: Boolean = false
  noteExists: Boolean = false
  notificationExists: Boolean = false  
  carrierServiceExists: boolean = false
  serviceExists: boolean = false  
  operationsProfileExists: boolean = false
  accountingProfileExists: boolean = false
  appointmentContactProfileExists: boolean = false
  wisbFormExists: boolean = false
  insuranceFormExists: boolean = false
  salesProfileExists: boolean = false

  // function to set checkboxes to their property (true or false), for different profiles
  isChecked(checkedProperty: string, profile: string): boolean {
    if (profile === "accounting_profile" && Object.keys(this.accounting_profile).length > 0) {
      return this.accounting_profile[checkedProperty];
    } else {
      return false
    }
  }

  private dateToLocalDate(s: string | null | undefined){
    if (!s) return null;
    const [y, m, d] = s.split('-').map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d); // local midnight
  }

    // default column definitions
  defaultColDef = {
    sortable: true,
    filter: true,
    autoHeight: true,
    cellClass: 'cell-wrap-text',
    resizable: true,
    editable: true
  }

  // define arrays of different types for selection dropdown
  typeListContact: any = [];

  typeList: string[] = [
    "Main Office",
    "Branch Office",
    "Plant",
    "Warehouse",
    "Home",
    "Store",
    "Mailing",
    "Accounting",
    "Terminal",
    "Job Site",
    "Remittance Address",
    "Physical Address",
  ];

  typeListPhone: string[] = [
    "Work",
    "Home",
    "Mobile",
    "Main",
    "Fax",
    "Pager",
    "Voicemail",
    "Text",
    "Toll Free",
    "Office",
    "After Hours",
    "Other",
  ];

  typeListService: string[] = [
    "Accessorial Service",
    "Service Program",
    "Surcharge Service",
    "Tradeshow Service",
    "Trailer Build Service",
    "Suncor Service",
    "Customs Service",
    "Delivery Service",
    "Pickup Service",
  ]

  typeListServiceType: string[] = [
    "Delivery After Hours",
    "Delivery Appointment",
    "Delivery Detention",
    "Delivery Rate",
    "Delivery Extra",
    "Delivery Inside",
    "Re-Delivery",
    "Delivery Residential",
    "Delivery Tailgate",
    "Delivery Weekend",
    "Delivery Notification",
    "Delivery Straight Truck",
    "Delivery Time Specific",
    "Delivery Date Time Specific",
    "Split Delivery",
    "Delivery Downtown",
    "Delivery Highcost Area",
    "Delivery Limited Access",
    "Delivery Attempted",
    "Delivery Advance Hours",
    "Delivery Certified",
    "Delivery Back Door",
  ]

  typeListSalesStatus: string[] = [
    "Pursuing",
    "Not Contacted",
    "Customer Routed",
    "Not Interested",
    "No Potential",
    "Satisfied Current Provider",
    "Dead",
  ]
  
  typeListAction: string[] = [
    "Phone",
    "Email",
    "Proposal",
    "Spot Rate",
  ]

  typeListSalesManager: string[] = [
    "John",
    "Manny",
    "Frank",
    "Dave",
    "Willis",
    "Trip",
    "Daniel",
    "Luke",
  ]  
  
  typeListSalesEvaluation: string[] = [
    "Accepted Proposal",
    "Competitive Quote",
    "Not Competitive On Price</",
    "Not Competitive On Service",
    "Not Enough To Change",
  ]
    
  // headers for the address grid
  addressColumnDefs = [
    { field: 'address_description', headerName: 'Description' },
    {
      field: 'address_type',
      headerName: 'Address Type',
      cellEditor: ContactTypeEditorComponent,
      cellEditorPopup: true,
      cellEditorParams: {
        multiple: false,
        types: this.typeList
      }
    },
    { field: 'address_street', headerName: 'Street' },
    { field: 'address_locality', headerName: 'City' },
    { field: 'address_region', headerName: 'State/Province' },
    { field: 'address_postal_code', headerName: 'Postal Code' },
    { field: 'address_country', headerName: 'Country' },
    {
      headerName: 'Edit', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-edit'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.editAddress(params);
          });
        });
        return button;        
      }, editable: false, width: 80, filter: false
    },   
    {
      headerName: 'Delete', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-trash'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.deleteAddress(params);
          });
        });
        return button;        
      }, editable: false, width: 120, filter: false,
    },  
    {
      headerName: 'Add New', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-plus'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.addAddress();
          });
        });
        return button;        
      }, editable: false, width: 200, filter: false,
    }       
  ]

  // headers for subcontacts grid
  subcontactColumnDefs = [
    { field: 'contact_name', headerName: 'Contact Name' },
    { field: 'contact_role', headerName: 'Contact Role' },    
    { field: 'phone_type_text', headerName: 'Contact Type' },       
    { field: 'phone_description', headerName: 'Phone Description' },
    {
      field: 'phone_type',
      headerName: 'Phone Type',
      cellEditor: ContactTypeEditorComponent,
      cellEditorPopup: true,
      cellEditorParams: {
        multiple: false,
        types: this.typeListPhone
      }
    },
    { field: 'phone_number', headerName: 'Phone Number' },
    { field: 'phone_extension', headerName: 'Phone Extension' },
    { field: 'contact_email', headerName: 'Email' },
    {
      headerName: 'Edit', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-edit'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.editPhone(params);
          });
        });
        return button;        
      }, editable: false, width: 80, filter: false
    },   
    {
      headerName: 'Delete', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-trash'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.deletePhone(params);
          });
        });
        return button;        
      }, editable: false, width: 120, filter: false,
    },  
    {
      headerName: 'Add New', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-plus'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.addPhone();
          });
        });
        return button;        
      }, editable: false, width: 200, filter: false,
    }       

  ]

  // headers for email grid
  urlColumnDefs = [
    { field: 'url_type', headerName: 'URL Type' },
    { field: 'url_primary', headerName: 'Primary URL' },
    { field: 'url_address', headerName: 'URL Address' },
    { field: 'url_description', headerName: 'URL Description' },
    {
      headerName: 'Edit', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-edit'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.editURL(params);
          });
        });
        return button;        
      }, editable: false, width: 80, filter: false
    },   
    {
      headerName: 'Delete', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-trash'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.deleteURL(params);
          });
        });
        return button;        
      }, editable: false, width: 120, filter: false,
    },  
    {
      headerName: 'Add New', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-plus'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.addURL();
          });
        });
        return button;        
      }, editable: false, width: 200, filter: false,
    }       

  ]
// headers for contact type grid
  typeColumnDefs = [
    { field: 'contact_type', headerName: 'Contact Type' },
    { field: 'contact_type_no', headerName: 'Contact Type No' },
    { field: 'note', headerName: 'Notes' },
    {
      headerName: 'Delete', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-trash'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.deleteType(params);
          });
        });
        return button;        
      }, editable: false, width: 120, filter: false,
    },  
    {
      headerName: 'Add New', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-plus'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.addType();
          });
        });
        return button;        
      }, editable: false, width: 200, filter: false,
    }       

  ]

  // headers for email table
  emailColumnDefs = [
    { field: 'email_label', headerName: 'Label' },
    { field: 'email_address', headerName: 'Address' },
    { field: 'email_description', headerName: 'Description' },
    {
      headerName: 'Edit', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-edit'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.editEmail(params);
          });
        });
        return button;        
      }, editable: false, width: 80, filter: false
    },       
    {
      headerName: 'Delete', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-trash'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.deleteEmail(params);
          });
        });
        return button;        
      }, editable: false, width: 120, filter: false,
    },  
    {
      headerName: 'Add New', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-plus'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.addEmail();
          });
        });
        return button;        
      }, editable: false, width: 200, filter: false,
    }       

  ]

  // headers for Notification table
  notificationColumnDefs = [
    { field: 'name', headerName: 'Contact Name' },
    { field: 'email', headerName: 'Email' },
    { field: 'phone_number', headerName: 'Phone Number' },   
    { field: 'at_pick_up', 
      headerName: 'At Pick Up' , 
      filter: false,
      width: 130 ,       
      valueFormatter: function (params: ValueFormatterParams) {
        if (params.value == null) return '❌';
        return params.value === "false" ? '❌' : '✅';
      }          
    },     
    { field: 'delayed_pick_up', 
      headerName: 'Delayed Pick Up' , 
      filter: false,
      width: 130 ,       
      valueFormatter: function (params: ValueFormatterParams) {
        if (params.value == null) return '❌';
        return params.value === "false" ? '❌' : '✅';
      }          
    },      
    { field: 'at_delivery', 
      headerName: 'At Delivery' , 
      filter: false,
      width: 130 ,       
      valueFormatter: function (params: ValueFormatterParams) {
        if (params.value == null) return '❌';
        return params.value === "false" ? '❌' : '✅';
      }          
    },      
    { field: 'delayed_delivery', 
      headerName: 'Delayed Delivery' , 
      filter: false,
      width: 130 ,       
      valueFormatter: function (params: ValueFormatterParams) {
        if (params.value == null) return '❌';
        return params.value === "false" ? '❌' : '✅';
      }          
    },      
    { field: 'assessorials_incurred', 
      headerName: 'Assessorials Incurred' , 
      filter: false,
      width: 130 ,       
      valueFormatter: function (params: ValueFormatterParams) {
        if (params.value == null) return '❌';
        return params.value === "false" ? '❌' : '✅';
      }          
    },      
    { field: 'phone_notification', 
      headerName: 'Phone Notification' , 
      filter: false,
      width: 130 ,       
      valueFormatter: function (params: ValueFormatterParams) {
        if (params.value == null) return '❌';
        return params.value === "false" ? '❌' : '✅';
      }          
    },      
    { field: 'sms_notification', 
      headerName: 'SMS Notification' , 
      filter: false,
      width: 130 ,       
      valueFormatter: function (params: ValueFormatterParams) {
        if (params.value == null) return '❌';
        return params.value === "false" ? '❌' : '✅';
      }          
    },      
    { field: 'email_notification', 
      headerName: 'Email Notification' , 
      filter: false,
      width: 130 ,       
      valueFormatter: function (params: ValueFormatterParams) {
        if (params.value == null) return '❌';
        return params.value === "false" ? '❌' : '✅';
      }          
    },      
    { field: 'appointment_pickup', 
      headerName: 'Appointment Pickup' , 
      filter: false,
      width: 130 ,       
      valueFormatter: function (params: ValueFormatterParams) {
        if (params.value == null) return '❌';
        return params.value === "false" ? '❌' : '✅';
      }          
    },      
    { field: 'appointment_delivery', 
      headerName: 'Appointment Delivery' , 
      filter: false,
      width: 130 ,       
      valueFormatter: function (params: ValueFormatterParams) {
        if (params.value == null) return '❌';
        return params.value === "false" ? '❌' : '✅';
      }          
    },      
    {
      headerName: 'Edit', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-edit'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.editNotification(params);
          });
        });
        return button;        
      }, editable: false, width: 80, filter: false
    },       
    {
      headerName: 'Delete', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-trash'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.deleteNotification(params);
          });
        });
        return button;        
      }, editable: false, width: 120, filter: false,
    },  
    {
      headerName: 'Add New', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-plus'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.addNotification();
          });
        });
        return button;        
      }, editable: false, width: 200, filter: false,
    }       

  ]

  // headers for email table
  noteColumnDefs = [
    { field: 'contact_note', headerName: 'Note' },
    {
      headerName: 'Edit', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-edit'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.editNote(params);
          });
        });
        return button;        
      }, editable: false, width: 80, filter: false
    },       
    {
      headerName: 'Delete', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-trash'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.deleteNote(params);
          });
        });
        return button;        
      }, editable: false, width: 120, filter: false,
    },  
    {
      headerName: 'Add New', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-plus'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.addNote();
          });
        });
        return button;        
      }, editable: false, width: 200, filter: false,
    }       

  ]


  // headers for the service rates grid
  serviceRatesColumnDefs = [
    { field: 'contact_uuid', headerName: 'Contact UUID', hide: true, editable: false },
    { field: 'carrier_service_rate_uuid', headerName: 'Carrier Service Rate UUID', hide: false, editable: false },
    {
      field: 'carrier_service',
      headerName: 'Service',
      cellEditor: ContactTypeEditorComponent,
      cellEditorPopup: true,
      cellEditorParams: {
        multiple: false,
        types: this.typeListService
      }
    },
    {
      field: 'carrier_service_type',
      headerName: 'Service Type',
      cellEditor: ContactTypeEditorComponent,
      cellEditorPopup: true,
      cellEditorParams: {
        multiple: false,
        types: this.typeListServiceType
      }
    },
    { field: 'service_option', headerName: 'Options' },
    { field: 'currency_type', headerName: 'Currency Type' },
    { field: 'flat_rate', headerName: 'Flat Rate' },
    { field: 'service_taxed', headerName: 'Service Taxed', cellRenderer: (params: any) => !params.value ? "No" : "Yes" },
    { field: 'service_tax_multiplier', headerName: 'Service Tax Multiplier' },
    { field: 'service_tax_cost', headerName: 'Service Tax' },
    { field: 'service_note', headerName: 'Note' },
    {
      headerName: 'Edit', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-edit'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.editService(params);
          });
        });
        return button;        
      }, editable: false, width: 80, filter: false
    },   
    {
      headerName: 'Delete', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-trash'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.deleteService(params);
          });
        });
        return button;        
      }, editable: false, width: 120, filter: false,
    },  
    {
      headerName: 'Add New', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-plus'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.addService();
          });
        });
        return button;        
      }, editable: false, width: 120, filter: false,
    }      
  ]

  // headers for the default services grid
  defaultServicesColumnDefs = [
    { field: 'contact_uuid', headerName: 'Contact UUID', editable: false, hide: true },
    { field: 'contact_profile_default_service_uuid', headerName: 'Contact Profile Default Service UUID', editable: false, hide: false },
    {
      field: 'service', headerName: 'Service',
      cellEditor: ContactTypeEditorComponent,
      cellEditorPopup: true,
      cellEditorParams: {
        multiple: false,
        types: this.typeListService
      }
    },
    {
      field: 'service_type', headerName: 'Service Type',
      cellEditor: ContactTypeEditorComponent,
      cellEditorPopup: true,
      cellEditorParams: {
        multiple: false,
        types: this.typeListServiceType
      }
    },
    {
      headerName: 'Edit', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-edit'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.editDefaultService(params);
          });
        });
        return button;        
      }, editable: false, width: 80, filter: false
    },   
    {
      headerName: 'Delete', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-trash'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.deleteDefaultService(params);
          });
        });
        return button;        
      }, editable: false, width: 120, filter: false,
    },  
    {
      headerName: 'Add New', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-plus'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.addDefaultService();
          });
        });
        return button;        
      }, editable: false, width: 120, filter: false,
    }      
  ]

  // Data sources
  documentsTable = new MatTableDataSource<ContactDocumentInfo>();

  // ---------------------------------------------------
  // Contructor for the componet
  constructor( 
      private activatedRoute: ActivatedRoute, 
      private http: HttpClient, 
      private formBuilder: FormBuilder,
      private toastr: ToastrService,
      private dialog: MatDialog,      
      private zone: NgZone      
  ) 
  { 
        this.initializeForms(); // execute after api call is done
  }

  ngOnInit(): void {

    this.isLoading = true;

    this.activatedRoute.paramMap.subscribe(params => {
      this.contact_uuid = params.get('uuid');
      if (!this.contact_uuid) {
        this.toastr.error('No UUID provided.');
        this.isLoading = false;
        return;
      }
      this.loadData();
    });

  }

  // Initialize all form groups
  private initializeForms(): void {

      // Build form for General Information
      this.generalInfoForm = this.formBuilder.group({
		    contact_uuid: '',
        contact_category: '',
        contact_email: '',
        contact_name_family: '',
        contact_name_given: '',
        contact_name_middle: '',
        contact_name_prefix: '',
        contact_name_suffix: '',
        contact_nickname: '',
        contact_note: '',
        contact_organization: '',
        contact_role: '',
        contact_title: '',
        contact_url: '',
        contact_parent_uuid: '',
        customer_contact_uuid: '',
        insurance_agent_uuid: '',
        payment_processor_uuid: '',
        carrier_contact_uuid: '',
        us_dot_no: '',
        pool_id: '',
        pool_location: '',
        drop_trailer_party: '',
        active: true
      })

      // Build form for Accounting tab
      this.accountingForm = this.formBuilder.group({
		    account_profile_uuid: '',
        on_hold: '',
        ap_batch_number: '',
        accounting_code: '',
        carrier_code: '',
        payment_terms: '',
        fuel_surcharged: '',
        tax_applied: '',
        ab_carbon_fuel_tax: '',
        bc_carbon_fuel_tax: '',
        tax_jurisdiction: '',
        can_tax_id: '',
        ufos_accpac_id: '',
        tax_id_number: '',
        account_type: '',
        account_currency: '',
        account_status: '',
        accounting_note: '',
        account_balance: '',
        account_balance_date: '',
        account_balance_days: '',
        credit_limit: '',
        interest_rate: '',
        report_group: '',
        pay_term: '',
        billing_code: '',
        specify_time: '',
        customs_charges: '',
        warehouse_charge: '',
        freight_insurance: '',
        insurance_percentage: '',
        insurance_minimum: '',
        pickup_rate: '',
        delivery_rate: '',
        hourly_rate: '',
        skid_fee: '',
        duns_number: '',
        invoice_comment: '',
        invoice_note: '',
        default_cube_factor: '',
        express_road: '',
      })
	  
	  // build form for the OPERATIONS tab
      this.operationsForm = this.formBuilder.group({
        contact_profile_uuid: '',
        contact_uuid: '',
        loading_dock: '',
        tailgate: '',
        ground_level: '',
        truck_space: '',
        straight_truck: '',
        high_cost: '',
        convention_center: '',
        pop_up: '',
        residential: '',
        elevator_inside: '',
        delivery_inside: '',
        hallway_corner: '',
        to_friday: '',
        to_saturday: '',
        to_thursday: '',
        seven_days: '',
        monday_only: '',
        tuesday_only: '',
        wednesday_only: '',
        thursday_only: '',
        friday_only: '',
        appointments: '',
        appointment_start: '',
        appointment_end: '',
        appointment_day: '',
        opening_time: '',
        closing_time: '',
        after_hours: '',
        access_loading: '',
        interprovincial: '',
        intraprovincial: '',
        canada_us_border: '',
        interstate: '',
        intrastate: '',
        operation_profile_province: '',
        operation_profile_state: '',
        mexico_border: '',
        canada_west: '',
        canada_central: '',
        canada_east: '',
        usa_new_england: '',
        usa_mid_atlantic: '',
        usa_great_lakes: '',
        usa_mid_west: '',
        usa_south_atlantic: '',
        usa_southeast: '',
        usa_south_central: '',
        usa_mountain: '',
        usa_pacific: '',
        usa_far_pacific: '',
        use_csa: '',
        use_fast: '',
        use_ace: '',
        use_aci: '',
        use_ct_pat: '',
        use_can_bond: '',
        use_us_bond: '',
        use_hazmat: '',
        protect_freezing: '',
        heated: '',
        refrigeration: '',
        use_food_grade: '',
        bol_shipping: '',
        bol_invoice: '',
        pod_invoice: '',
        purchase_order_number_invoice: '',
        rate_quote_copy: '',
        pick_up_reference_number: '',
        delivery_reference_number: '',
      })

      // build form for the APPOINTMENT CONTACT SECTION of the OPERATIONS tab
      this.appointmentContactForm = this.formBuilder.group({
        contact_profile_appointment_contact_uuid: '',
        contact_uuid: '',     
        contact_profile_uuid: '',   
        name: '',
        email: '',
        phone_number: '',
        mobile_number: '',
      })
	  
	  // Build form for WSIB Form
      this.wisbForm = this.formBuilder.group({
          wisb_form_uuid: '',
          legal_name: '',
          business_name: '',
          us_taxpayer_id_no: '',
          wisb_account_no: '',
          other: '',
          individual_proprietor: '',
          c_corporation: '',
          s_corportation: '',
          partnership: '',
          trust_estate: '',           
          llc_llp: '',    
          exempt_payee: '',    
          address_street: '',    
          address_extended: '',    
          address_locality: '',    
          address_region: '',    
          address_country: '',    
          address_postal_code: '',    
          wisb_certificate_no: '',    
          wisb_certificate_valid: ['1970-01-01'],   
      })
	  
	  
	  // Build form for Insurance Form
      this.insuranceForm = this.formBuilder.group({
		insurance_form_uuid: '',
        policy_no: '',
        gl_limit: '',
        gl_expires: ['1970-01-01'],
        auto_expires: ['1970-01-01'],
        auto_limit: '',
        cargo_expires: ['1970-01-01'],
        cargo_limit: '',
        wc_expires: ['1970-01-01'],
        insurance_agent_information: '',
        agent_phone: '',
        agent_fax: '',       
        description: '',   
        agent_contact_uuid: '',   
        agent_name: '',   
        previous_theft_claim: '',   
        computers: '',   
        electronics: '',   
        liguor: '',   
        theft: '',   
        unsecure_yard: '',   
        other_exclusion: '',                        
        agent_email: '',  
        licensing: '',  
      })	  

	  // Build form for Insurance Form
    this.salesProfileForm = this.formBuilder.group({
      sales_profile_uuid: '',
      sales_status: '',
      last_action: '',
      username: '',
      cross_border: '',
      us_only: '',
      canada_only: '',
      warehouse_distribution: '',
      specialized_services: '',
      tradeshow_freight: '',       
      trailer_build: '',   
      action_type: '',
      drip_status: '',
      sales_potential: '',
      sales_manager: '',
      current_provider: '',
      sales_evaluation: '',
    })	  

  }

  // Load all data for the work order
  private async loadData(): Promise<void> {
    if (!this.contact_uuid) return;

    this.isLoading = true;

      const contact_details_url = `/api/contacts/contact_details.php?uuid=${this.contact_uuid}`;
      const contact_profiles_url = `/api/contacts/contact_details_profiles.php?uuid=${this.contact_uuid}&table=contact_profile_outline`;

      // GET request to the contacts API call for specific contact_UUID
      this.http.get<any>(contact_details_url).subscribe(response => {
        console.log("RESPONSE:", response)
        this.contact_organization = response.contact_organization
        this.general_info = response
        this.address_details = response.addresses
        if (response.addresses[0])
        {
            this.addressExists = true;
        }
        this.subcontact_details = response.sub_contacts
        if (response.sub_contacts[0])
        {
            this.phoneExists = true;
        }            
        this.url_details = response.urls
        if (response.urls[0])
        {
            this.urlExists = true;
        }            
        this.type_details = response.types
        if (response.types[0])
        {
            this.typeExists = true;
        }              
        this.email_details = response.emails
        if (response.emails[0])
        {
            this.emailExists = true;
        }              
        this.note_details = response.notes
        if (response.notes[0])
        {
            this.noteExists = true;
        }              
        this.notification_details = response.profile_default_notifications
        if (response.profile_default_notifications[0])
        {
            this.notificationExists = true;
        }              

        if (response.profile_default_services[0]) 
        {
          this.contact_profile_default_services = response.profile_default_services
          this.serviceExists = true;
        }

        if (response.profiles["0"])
        {
          this.contact_profile = response.profiles["0"]
          this.contact_profile_uuid = this.contact_profile.contact_profile_uuid
          this.operationsProfileExists = true          
        }

        if (response.profile_appointment_contacts['0'])
        {
            this.contact_profile_appointment_contacts = response.profile_appointment_contacts['0']
            this.appointment_contact_uuid = response.profile_appointment_contacts['0'].contact_profile_appointment_contact_uuid
            this.appointmentContactProfileExists = true
        }   

        if (response.documents[0]) {
          this.documentsTable = new MatTableDataSource(response.documents || []);
        }             

        if (response.accounting_profiles[0]) 
        {
          this.accounting_profile = response.accounting_profiles[0]
          this.accounting_profile_uuid = response.accounting_profiles[0].accounting_profile_uuid
          this.accountingProfileExists = true
        }
         
        if (response.insurance_forms[0]) 
        {
          this.insurance_form = response.insurance_forms[0]
          this.insurance_form_uuid = response.insurance_forms[0].insurance_form_uuid;
          this.insuranceFormExists = true
        }        

        if (response.wisb_forms[0]) 
        {
          this.wisb_forms = response.wisb_forms[0]
          this.wisb_form_uuid = response.wisb_forms[0].wisb_form_uuid;
          this.wisbFormExists = true
        }          
        
        if (response.sales_profiles[0]) 
        {
          this.sales_profile = response.sales_profiles[0]
          this.sales_profile_uuid = response.wisb_forms[0].sales_profile_uuid;
          this.salesProfileExists = true
        }          
        this.checkFormReady(); // Initialize the form while it's waiting 
      })

      // GET request to the contacts API call for specific contact_UUID
      this.http.get<any>(contact_profiles_url).subscribe(response => {
        console.log("PROFILE:", response)

        if (response.carrier_service_rates[0]) {
          this.service_rates = response.carrier_service_rates
          this.carrierServiceExists = true;
        }        
                          
        this.checkProfileFormReady(); // Initialize the form while it's waiting 
      })
      this.isLoading = false;      
  }

  // function to allow for cell editing in the grid, POST request is made when cell editing is finished
  onCellEditingStopped(event: CellEditingStoppedEvent) {

    // grab the value being edited, column, and row
    const editedValue = event.value;
    const column = event.column;
    const rowNode = event.node;

    // grab UUIDs from the contact profile outline to send to appropriate API calls
    const contact_address_uuid = rowNode.data.contact_address_uuid
    const carrier_service_rate_uuid = rowNode.data.carrier_service_rate_uuid;
    const default_service_uuid = rowNode.data.contact_profile_default_service_uuid;
    const phone_uuid = rowNode.data.contact_phone_uuid

    // create URLS to send POST data to
    const service_rate_url = `/api/contacts/contact_details_profiles.php?uuid=${carrier_service_rate_uuid}&table=carrier_service_rates`;
    const default_service_url = `/api/contacts/contact_details_profiles.php?uuid=${default_service_uuid}&table=contact_profile_default_services`;
    const address_url = `/api/contacts/contact_details_profiles.php?uuid=${contact_address_uuid}&table=contact_addresses`;
    const phone_url = `/api/contacts/contact_details_profiles.php?uuid=${phone_uuid}&table=contact_phones`;

    // grab column name for testing conditions for which API to pos tto
    const columnName = column.getColId();

    // create POST body of cell edited of column, columnName, and value changed, editedValue
    var postData = {
      [columnName]: editedValue
    }

    // if an edit is made in the SERVICE RATES table
    if (columnName === 'carrier_service' ||
      columnName === 'carrier_service_type' ||
      columnName === 'service_option' ||
      columnName === 'address_postal_code' ||
      columnName === 'currency_type' ||
      columnName === 'flat_rate' ||
      columnName === 'service_taxed' ||
      columnName === 'service_tax_multiplier' ||
      columnName === 'service_tax_cost' ||
      columnName === 'service_note') {

      return this.http.post<any>(service_rate_url, postData)
        .subscribe(response => {
          console.log('Post Response: ', response)
        })

      // if an edit is made in the DEFAULT SERVICE CHARGES table
    } else if (columnName === 'service' ||
      columnName === 'service_type') {

      return this.http.post<any>(default_service_url, postData)
        .subscribe(response => {
          console.log('Post Response: ', response)
        })

      // if an edit is made in the CONTACT ADDRESSES table
    } else if (columnName === 'address_description' ||
      columnName === 'address_street' ||
      columnName === 'address_type' ||
      columnName === 'address_community' ||
      columnName === 'address_locality' ||
      columnName === 'address_region' ||
      columnName === 'address_postal_code' ||
      columnName === 'address_country') {

      return this.http.post<any>(address_url, postData)
        .subscribe(response => {
          console.log('Post Response: ', response)
        })

    } else if (columnName === 'phone_description' ||
      columnName === 'phone_type' ||
      columnName === 'phone_number' ||
      columnName === 'phone_extension' ||
      columnName === 'contact_email' ||
      columnName === 'contact_name') {

      return this.http.post<any>(phone_url, postData)
        .subscribe(response => {
          console.log('Post Response: ', response)
        })

    } else {
      return
    }
  }  

  // check if API is finished loading -> populate all the different forms using formbuilder
  // and set show content to true at the end to render HTML
  private checkFormReady(): void {
      
    console.log("General Info:", this.general_info)
    // build form for the General Information
    this.generalInfoForm = this.formBuilder.group({
      contact_uuid: [this.general_info['contact_uuid']],        
      contact_organization: [this.general_info['contact_organization']],
      contact_category: [this.general_info['contact_category']],
      contact_role: [this.general_info['contact_role']],
      contact_title: [this.general_info['contact_title']],
      contact_name_family: [this.general_info['contact_name_family']],
      contact_name_given: [this.general_info['contact_name_given']],
      contact_name_middle: [this.general_info['contact_name_middle']],
      contact_name_prefix: [this.general_info['contact_name_prefix']],
      contact_name_suffix: [this.general_info['contact_name_suffix']],
      contact_nickname: [this.general_info['contact_nickname']],
      contact_note: [this.general_info['contact_note']],
      contact_email: [this.general_info['contact_email']],
      contact_url: [this.general_info['contact_url']],
      contact_parent_uuid: [this.general_info['contact_parent_uuid']],
      customer_contact_uuid: [this.general_info['customer_contact_uuid']],
      insurance_agent_uuid: [this.general_info['insurance_agent_uuid']],
      payment_processor_uuid: [this.general_info['payment_processor_uuid']],
      carrier_contact_uuid: [this.general_info['carrier_contact_uuid']],
      us_dot_no: [this.general_info['us_dot_no']],
      pool_id: [this.general_info['pool_id']],
      pool_location: [this.general_info['pool_location']],
      drop_trailer_party: [this.general_info['drop_trailer_party']],
      active: [this.general_info['active']]
    })

    if (this.contact_profile) 
    {
      console.log("Operation Profile:", this.contact_profile)
      // build form for the OPERATIONS tab
      this.operationsForm = this.formBuilder.group({
        contact_profile_uuid: [this.contact_profile.contact_profile_uuid],
        contact_uuid: [this.contact_profile.contact_uuid],
        loading_dock: [this.contact_profile.loading_dock],
        tailgate: [this.contact_profile.tailgate],
        ground_level: [this.contact_profile.ground_level],
        truck_space: [this.contact_profile.truck_space],
        straight_truck: [this.contact_profile.straight_truck],
        high_cost: [this.contact_profile.high_cost],
        convention_center: [this.contact_profile.convention_center],
        pop_up: [this.contact_profile.pop_up],
        residential: [this.contact_profile.residential],
        elevator_inside: [this.contact_profile.elevator_inside],
        delivery_inside: [this.contact_profile.delivery_inside],
        hallway_corner: [this.contact_profile.hallway_corner],
        to_friday: [this.contact_profile.to_friday],
        to_saturday: [this.contact_profile.to_saturday],
        to_thursday: [this.contact_profile.to_thursday],
        seven_days: [this.contact_profile.seven_days],
        monday_only: [this.contact_profile.monday_only],
        tuesday_only: [this.contact_profile.tuesday_only],
        wednesday_only: [this.contact_profile.wednesday_only],
        thursday_only: [this.contact_profile.thursday_only],
        friday_only: [this.contact_profile.friday_only],
        appointments: [this.contact_profile.appointments],
        appointment_start: [this.contact_profile.appointment_start],
        appointment_end: [this.contact_profile.appointment_end],
        appointment_day: [this.contact_profile.appointment_day],
        opening_time: [this.contact_profile.opening_time],
        closing_time: [this.contact_profile.closing_time],
        after_hours: [this.contact_profile.after_hours],
        access_loading: [this.contact_profile.access_loading],      
        interprovincial: [this.contact_profile.interprovincial],
        intraprovincial: [this.contact_profile.intraprovincial],
        canada_us_border: [this.contact_profile.canada_us_border],
        interstate: [this.contact_profile.interstate],
        intrastate: [this.contact_profile.intrastate],
        operation_profile_province: [this.contact_profile.operation_profile_province],
        operation_profile_state: [this.contact_profile.operation_profile_state],
        mexico_border: [this.contact_profile.mexico_border],
        canada_west: [this.contact_profile.canada_west],
        canada_central: [this.contact_profile.canada_central],
        canada_east: [this.contact_profile.canada_east],
        usa_new_england: [this.contact_profile.usa_new_england],
        usa_mid_atlantic: [this.contact_profile.usa_mid_atlantic],
        usa_great_lakes: [this.contact_profile.usa_great_lakes],
        usa_mid_west: [this.contact_profile.usa_mid_west],
        usa_south_atlantic: [this.contact_profile.usa_south_atlantic],
        usa_southeast: [this.contact_profile.usa_southeast],
        usa_south_central: [this.contact_profile.usa_south_central],
        usa_mountain: [this.contact_profile.usa_mountain],
        usa_pacific: [this.contact_profile.usa_pacific],
        usa_far_pacific: [this.contact_profile.usa_far_pacific],
        use_csa: [this.contact_profile.use_csa],
        use_fast: [this.contact_profile.use_fast],
        use_ace: [this.contact_profile.use_ace],
        use_aci: [this.contact_profile.use_aci],
        use_ct_pat: [this.contact_profile.use_ct_pat],
        use_can_bond: [this.contact_profile.use_can_bond],
        use_us_bond: [this.contact_profile.use_us_bond],
        use_hazmat: [this.contact_profile.use_hazmat],
        protect_freezing: [this.contact_profile.protect_freezing],
        heated: [this.contact_profile.heated],
        refrigeration: [this.contact_profile.refrigeration],
        use_food_grade: [this.contact_profile.use_food_grade],
        bol_shipping: [this.contact_profile.bol_shipping],
        bol_invoice: [this.contact_profile.bol_invoice],
        pod_invoice: [this.contact_profile.pod_invoice],
        purchase_order_number_invoice: [this.contact_profile.purchase_order_number_invoice],
        rate_quote_copy: [this.contact_profile.rate_quote_copy],
        pick_up_reference_number: [this.contact_profile.pick_up_reference_number],
        delivery_reference_number: [this.contact_profile.delivery_reference_number],
      })

    }
    if (this.contact_profile_appointment_contacts) 
    {
      console.log("Appointment Contact:", this.contact_profile_appointment_contacts)
      // build form for the APPOINTMENT CONTACT SECTION of the OPERATIONS tab
      this.appointmentContactForm = this.formBuilder.group({
        contact_profile_appointment_contact_uuid: [this.contact_profile_appointment_contacts['contact_profile_appointment_contact_uuid']],
        contact_uuid: [this.contact_profile_appointment_contacts['contact_uuid']],        
        contact_profile_uuid:  [this.contact_profile.contact_profile_uuid],    
        name: [this.contact_profile_appointment_contacts['name']],
        email: [this.contact_profile_appointment_contacts['email']],
        phone_number: [this.contact_profile_appointment_contacts['phone_number']],
        mobile_number: [this.contact_profile_appointment_contacts['mobile_number']],
      })
    }

    if (this.accounting_profile) 
    {
      console.log("Accounting Profile:", this.accounting_profile)
      // build form for the ACCOUNTING PROFILE tab
      this.accountingForm = this.formBuilder.group({
        on_hold: [this.accounting_profile.on_hold],
        ap_batch_number: [this.accounting_profile.ap_batch_number],
        accounting_code: [this.accounting_profile.accounting_code],
        carrier_code: [this.accounting_profile.carrier_code],
        payment_terms: [this.accounting_profile.payment_terms],
        fuel_surcharged: [this.accounting_profile.fuel_surcharged],
        tax_applied: [this.accounting_profile.tax_applied],
        ab_carbon_fuel_tax: [this.accounting_profile.ab_carbon_fuel_tax],
        bc_carbon_fuel_tax: [this.accounting_profile.bc_carbon_fuel_tax],
        tax_jurisdiction: [this.accounting_profile.tax_jurisdiction],
        can_tax_id: [this.accounting_profile.can_tax_id],
        ufos_accpac_id: [this.accounting_profile.ufos_accpac_id],
        tax_id_number: [this.accounting_profile.tax_id_number],
        account_type: [this.accounting_profile.account_type],
        account_currency: [this.accounting_profile.account_currency],
        account_status: [this.accounting_profile.account_status],
        accounting_note: [this.accounting_profile.accounting_note],
        account_balance: [this.accounting_profile.account_balance],
        account_balance_date: [this.accounting_profile.account_balance_date],
        account_balance_days: [this.accounting_profile.account_balance_days],
        credit_limit: [this.accounting_profile.credit_limit],
        interest_rate: [this.accounting_profile.interest_rate],
        report_group: [this.accounting_profile.report_group],
        pay_term: [this.accounting_profile.pay_term],
        billing_code: [this.accounting_profile.billing_code],
        specify_time: [this.accounting_profile.specify_time],
        customs_charges: [this.accounting_profile.customs_charges],
        warehouse_charge: [this.accounting_profile.warehouse_charge],
        freight_insurance: [this.accounting_profile.freight_insurance],
        insurance_percentage: [this.accounting_profile.insurance_percentage],
        insurance_minimum: [this.accounting_profile.insurance_minimum],
        pickup_rate: [this.accounting_profile.pickup_rate],
        delivery_rate: [this.accounting_profile.delivery_rate],
        hourly_rate: [this.accounting_profile.hourly_rate],
        skid_fee: [this.accounting_profile.skid_fee],
        duns_number: [this.accounting_profile.duns_number],
        invoice_comment: [this.accounting_profile.invoice_comment],
        invoice_note: [this.accounting_profile.invoice_note],
        default_cube_factor: [this.accounting_profile.default_cube_factor],
        express_road: [this.accounting_profile.express_road],
      });
    }

    if (this.wisb_forms) 
    {
      console.log("WSIB:", this.wisb_forms)
      // build form for the WSIB Form
      this.wisbForm = this.formBuilder.group({
        wisb_form_uuid: [this.wisb_forms['wisb_form_uuid']],
        contact_uuid: [this.wisb_forms['contact_uuid']],        
        legal_name: [this.wisb_forms['legal_name']],
        business_name: [this.wisb_forms['business_name']],
        us_taxpayer_id_no: [this.wisb_forms['us_taxpayer_id_no']],
        wisb_account_no: [this.wisb_forms['wisb_account_no']],
        other: [this.wisb_forms['other']],
        individual_proprietor: [this.wisb_forms['individual_proprietor']],
        c_corporation: [this.wisb_forms['c_corporation']],
        s_corportation: [this.wisb_forms['s_corportation']],
        partnership: [this.wisb_forms['partnership']],
        trust_estate: [this.wisb_forms['trust_estate']],
        llc_llp: [this.wisb_forms['llc_llp']],
        exempt_payee: [this.wisb_forms['exempt_payee']],
        address_street: [this.wisb_forms['address_street']],
        address_extended: [this.wisb_forms['address_extended']],
        address_locality: [this.wisb_forms['address_locality']],
        address_region: [this.wisb_forms['address_region']],
        address_country: [this.wisb_forms['address_country']],
        address_postal_code: [this.wisb_forms['address_postal_code']],
        wisb_certificate_no: [this.wisb_forms['wisb_certificate_no']],
        wisb_certificate_valid: this.dateToLocalDate(this.wisb_forms['wisb_certificate_valid'].date),
      })      
    }

    if (this.insurance_form) 
    {
      console.log("Insurance Form:", this.insurance_form)
      // build form for the WSIB Form
      this.insuranceForm = this.formBuilder.group({
        insurance_form_uuid: [this.insurance_form['insurance_form_uuid']],
        contact_uuid: [this.insurance_form['contact_uuid']],        
        policy_no: [this.insurance_form['policy_no']],
        gl_expires: this.dateToLocalDate(this.insurance_form['gl_expires'].date),
        gl_limit: [this.insurance_form['gl_limit']],
        auto_expires: this.dateToLocalDate(this.insurance_form['auto_expires'].date),
        auto_limit: [this.insurance_form['auto_limit']],
        cargo_expires: this.dateToLocalDate(this.insurance_form['cargo_expires'].date),
        cargo_limit: [this.insurance_form['cargo_limit']],
        wc_expires: this.dateToLocalDate(this.insurance_form['wc_expires'].date),
        insurance_agent_information: [this.insurance_form['insurance_agent_information']],
        agent_phone: [this.insurance_form['agent_phone']],
        agent_fax: [this.insurance_form['agent_fax']],
        description: [this.insurance_form['description']],
        agent_contact_uuid: [this.insurance_form['agent_contact_uuid']],
        agent_name: [this.insurance_form['agent_name']],
        previous_theft_claim: [this.insurance_form['previous_theft_claim']],
        computers: [this.insurance_form['computers']],
        electronics: [this.insurance_form['electronics']],
        liguor: [this.insurance_form['liguor']],
        theft: [this.insurance_form['theft']],
        unsecure_yard: [this.insurance_form['unsecure_yard']],
        other_exclusion: [this.insurance_form['other_exclusion']],
        agent_email: [this.insurance_form['agent_email']],
        licensing: [this.insurance_form['licensing']],
      })      
    }

    if (this.sales_profile) 
    {
      console.log("Sales Profile:", this.sales_profile)
      // build form for the sales Profile
      this.salesProfileForm = this.formBuilder.group({
          sales_profile_uuid: [this.sales_profile['sales_profile_uuid']],
          sales_status: [this.sales_profile['sales_status']],
          last_action: [this.sales_profile['last_action']],
          username: [this.sales_profile['username']],
          cross_border: [this.sales_profile['cross_border']],
          us_only: [this.sales_profile['us_only']],
          canada_only: [this.sales_profile['canada_only']],
          warehouse_distribution: [this.sales_profile['warehouse_distribution']],
          specialized_services: [this.sales_profile['specialized_services']],
          tradeshow_freight: [this.sales_profile['tradeshow_freight']],       
          trailer_build: [this.sales_profile['trailer_build']],   
          action_type: [this.sales_profile['action_type']],
          drip_status: [this.sales_profile['drip_status']],
          sales_potential: [this.sales_profile['sales_potential']],
          sales_manager: [this.sales_profile['sales_manager']],
          current_provider: [this.sales_profile['current_provider']],
          sales_evaluation: [this.sales_profile['sales_evaluation']],         
      })      
    }
  }

  private checkProfileFormReady(): void {
  }

  // function to submit the POST request to update/create ACCOUNTING profile
  submitAccountingForm(): void {
    // set the form to the accounting form's current values
    const formData = this.accountingForm.value;

    // set T/F fields
    formData.on_hold = formData.on_hold ? 't' : 'f';
    formData.tax_applied = formData.tax_applied ? 't' : 'f';
    formData.ab_carbon_fuel_tax = formData.ab_carbon_fuel_tax ? 't' : 'f';
    formData.bc_carbon_fuel_tax = formData.bc_carbon_fuel_tax ? 't' : 'f';
    formData.express_road = formData.express_road ? 't' : 'f';

    let url = '';

    // if accounting profile uuid is blank, create new accounting profile
    if (this.accountingProfileExists)
    {
      // if account profile uuid exists, update existing accounting profile passing the uuid
      url = `/api/contacts/contact_details_profiles.php?uuid=${this.accounting_profile_uuid}&table=accounting_profiles`;

      this.http.post<any>(url, formData)
        .subscribe(response => {
          console.log('Post Response: ', response)
        })
    } 
    else 
    {
      formData.contact_uuid = this.contact_uuid;
      url = `/api/contacts/contact_details_profiles.php?table=accounting_profiles`;
      // set accounting profile boolean to true to update buttons
      this.accountingProfileExists = true

      this.http.post<any>(url, formData)
        .subscribe(response => {

          // set accounting profile uuid to the newly created accounting profile uuid
          this.accounting_profile_uuid = response.details[0].uuid
          this.loadData();
        })

    }
  }

  // function to submit the POST request to update/create OPERATIONS profile
  submitOperationsForm(): void {
    // set the form to the operation form's current values
    const formData = this.operationsForm.value;

    // set T/F fields
    formData.loading_dock = formData.loading_dock ? 't' : 'f';
    formData.tailgate = formData.tailgate ? 't' : 'f';
    formData.ground_level = formData.ground_level ? 't' : 'f';
    formData.straight_truck = formData.straight_truck ? 't' : 'f';
    formData.truck_space = formData.truck_space ? 't' : 'f';
    formData.high_cost = formData.high_cost ? 't' : 'f';
    formData.convention_center = formData.convention_center ? 't' : 'f';
    formData.pop_up = formData.pop_up ? 't' : 'f';
    formData.residential = formData.residential ? 't' : 'f';
    formData.elevator_inside = formData.elevator_inside ? 't' : 'f';
    formData.delivery_inside = formData.delivery_inside ? 't' : 'f';
    formData.hallway_corner = formData.hallway_corner ? 't' : 'f';
    formData.to_friday = formData.to_friday ? 't' : 'f';
    formData.to_saturday = formData.to_saturday ? 't' : 'f';
    formData.to_thursday = formData.to_thursday ? 't' : 'f';
    formData.seven_days = formData.seven_days ? 't' : 'f';
    formData.monday_only = formData.monday_only ? 't' : 'f';
    formData.tuesday_only = formData.tuesday_only ? 't' : 'f';
    formData.wednesday_only = formData.wednesday_only ? 't' : 'f';
    formData.thursday_only = formData.thursday_only ? 't' : 'f';
    formData.friday_only = formData.friday_only ? 't' : 'f';
    formData.appointments = formData.appointments ? 't' : 'f';
    formData.after_hours = formData.after_hours ? 't' : 'f';
    formData.access_loading = formData.access_loading ? 't' : 'f';
    formData.interprovincial = formData.interprovincial ? 't' : 'f';
    formData.intraprovincial = formData.intraprovincial ? 't' : 'f';
    formData.canada_us_border = formData.canada_us_border ? 't' : 'f';
    formData.interstate = formData.interstate ? 't' : 'f';
    formData.intrastate = formData.intrastate ? 't' : 'f';
    formData.canada_west = formData.canada_west ? 't' : 'f';
    formData.canada_central = formData.canada_central ? 't' : 'f';
    formData.canada_east = formData.canada_east ? 't' : 'f';
    formData.usa_new_england = formData.usa_new_england ? 't' : 'f';
    formData.usa_mid_atlantic = formData.usa_mid_atlantic ? 't' : 'f';
    formData.usa_great_lakes = formData.usa_great_lakes ? 't' : 'f';
    formData.usa_south_atlantic = formData.usa_south_atlantic ? 't' : 'f';
    formData.usa_southeast = formData.usa_southeast ? 't' : 'f';
    formData.usa_south_central = formData.usa_south_central ? 't' : 'f';
    formData.usa_mountain = formData.usa_mountain ? 't' : 'f';
    formData.usa_pacific = formData.usa_pacific ? 't' : 'f';
    formData.usa_far_pacific = formData.usa_far_pacific ? 't' : 'f';
    formData.use_csa = formData.use_csa ? 't' : 'f';
    formData.use_fast = formData.use_fast ? 't' : 'f';
    formData.use_ace = formData.use_ace ? 't' : 'f';
    formData.use_aci = formData.use_aci ? 't' : 'f';
    formData.use_ct_pat = formData.use_ct_pat ? 't' : 'f';
    formData.use_can_bond = formData.use_can_bond ? 't' : 'f';
    formData.use_us_bond = formData.use_us_bond ? 't' : 'f';
    formData.use_hazmat = formData.use_hazmat ? 't' : 'f';
    formData.protect_freezing = formData.protect_freezing ? 't' : 'f';
    formData.heated = formData.heated ? 't' : 'f';
    formData.refrigeration = formData.refrigeration ? 't' : 'f';
    formData.use_food_grade = formData.use_food_grade ? 't' : 'f';
    formData.bol_shipping = formData.bol_shipping ? 't' : 'f';
    formData.bol_invoice = formData.bol_invoice ? 't' : 'f';
    formData.pod_invoice = formData.pod_invoice ? 't' : 'f';
    formData.purchase_order_number_invoice = formData.purchase_order_number_invoice ? 't' : 'f';
    formData.rate_quote_copy = formData.rate_quote_copy ? 't' : 'f';
    formData.pick_up_reference_number = formData.pick_up_reference_number ? 't' : 'f';
    formData.delivery_reference_number = formData.delivery_reference_number ? 't' : 'f';

    const operation_url = `/api/contacts/contact_details.php?uuid=${this.contact_uuid}`;
    var postData = {
      ['profiles']: [formData],
    }

    // if contact profile uuid is empty, create new contact profile 
    if (this.operationsProfileExists) 
    {
      // if contact profile uuid exists, update existing contact profile   
      console.log('Edit Operation');
      this.http.put<any>(operation_url, postData)
        .subscribe(response => {
          console.log('Post Response: ', response)
          this.toastr.success('You Saved a Operation Profile Successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });        
        })
    } 
    else 
    {
      // set operations profile boolean to true to update buttons
      this.operationsProfileExists = true
      console.log('New Operation');
      this.http.put<any>(operation_url, postData)
        .subscribe(response => {
          this.toastr.success('You added a Operation Profile Successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });       
            this.loadData();       
        })
    }
  }

  // function to submit the POST request to update General Information
  submitGeneralInfoForm(): void {
    // set the form to the general information form's current values
    const formData = this.generalInfoForm.value;
    formData.active = formData.active ? 't' : 'f';

    var postData = {
      ['contact']: [formData],
    }

    console.log('General Information: ', postData)
    const general_info_url = `/api/contacts/contact_details.php?uuid=${this.contact_uuid}`;
      this.http.put<any>(general_info_url, postData)
        .subscribe(response => {
          console.log('Post Response: ', response)
          this.toastr.success('You Saved the General Information Successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });            
        })
  }


  // function to submit the POST request to update/create APPOINTMENT CONTACT profile
  submitAppointmentForm(): void {
    // set the form to the appointment contact form's current values
    const formData = this.appointmentContactForm.value;
    const appointment_contact_url = `/api/contacts/contact_details.php?uuid=${this.contact_uuid}`;
    var postData = {
      ['profile_appointment_contacts']: [formData],
    }

    // if appointment contact uuid is empty, create new appointment contact
    if (this.appointmentContactProfileExists) 
    {
      console.log('Edit Appointment Contact');
      // if contact profile uuid exists, update existing contact profile    
      this.http.put<any>(appointment_contact_url, postData)
        .subscribe(response => {
          console.log('Post Response: ', response)
          this.toastr.success('You Saved a Operation Profile Successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });         
            this.loadData();     
        })

    } 
    else 
    {
      console.log('New Appointment Contact');
      // set appointment contact profile boolean to true to update buttons
      this.appointmentContactProfileExists = true
      this.http.put<any>(appointment_contact_url, postData)
        .subscribe(response => {
          console.log('Post Response: ', response)
          this.toastr.success('You Added an Appointment Contact Successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });           
            this.loadData();
        })
    }
  }

  // function to submit the POST request to update/create 
  submitWISBForm(): void {
    // set the form to the accounting form's current values
    const formData = this.wisbForm.value;

    const wisb_url = `/api/contacts/contact_details.php?uuid=${this.contact_uuid}`;
    var postData = {
      ['wisb_forms']: [formData],
    }

    // if wisb_form uuid is empty, create new wisb Form 
    if (this.wisbFormExists) 
    {
      // if wisb Form exists, update existing wisb Form   
      console.log('Edit Operation');
      this.http.put<any>(wisb_url, postData)
        .subscribe(response => {
          console.log('Post Response: ', response)
          this.toastr.success('You Saved a WISB Form Successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });     
            this.loadData();         
        })
    } 
    else 
    {
      // set WISB Form boolean to true to update buttons
      this.wisbFormExists = true
      console.log('New WISB Form', postData);
      this.http.put<any>(wisb_url, postData)
        .subscribe(response => {
          this.toastr.success('You added a WISB Form Successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });          
            this.loadData();    
        })
    }
  }

  // function to submit the POST request to update/create 
  submitInsuranceForm(): void {
    // set the form to the accounting form's current values
    const formData = this.insuranceForm.value;

    formData.previous_theft_claim = formData.previous_theft_claim ? 't' : 'f';
    formData.computers = formData.computers ? 't' : 'f';
    formData.electronics = formData.electronics ? 't' : 'f';
    formData.liguor = formData.liguor ? 't' : 'f';
    formData.theft = formData.theft ? 't' : 'f';
    formData.unsecure_yard = formData.unsecure_yard ? 't' : 'f';

    const insurance_form_url = `/api/contacts/contact_details.php?uuid=${this.contact_uuid}`;
    var postData = {
      ['insurance_forms']: [formData],
    }

    // if insurance Form uid is empty, create new insurance Form 
    if (this.insuranceFormExists) 
    {
      // if insurance Form  uuid exists, update existing insurance Form    
      console.log('Edit Insurance Form:', postData);
      this.http.put<any>(insurance_form_url, postData)
        .subscribe(response => {
          console.log('Post Response: ', response)
          this.toastr.success('You Saved a Insurance Form Successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });        
            this.loadData();  
        })
    } 
    else 
    {
      // set insurance Form  boolean to true to update buttons
      this.insuranceFormExists = true
      console.log('New Insurance Form:', postData);
      this.http.put<any>(insurance_form_url, postData)
        .subscribe(response => {
          this.toastr.success('You added a Insurance Form Successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });        
            this.loadData();      
        })
    }
  }

  // function to submit the POST request to update/create 
  submitSalesProfile(): void {
    // set the form to the accounting form's current values
    const formData = this.salesProfileForm.value;

    const sales_profile_url = `/api/contacts/contact_details.php?uuid=${this.contact_uuid}`;
    var postData = {
      ['sales_profiles']: [formData],
    }

    // if insurance Form uid is empty, create new Sales Profile
    if (this.salesProfileExists) 
    {
      // if insurance Form  uuid exists, update existing Sales Profile
      console.log('Edit Sales Profile:', postData);
      this.http.put<any>(sales_profile_url, postData)
        .subscribe(response => {
          console.log('Post Response: ', response)
          this.toastr.success('You Saved a Sales Profile Successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });  
            this.loadData();  
        })

    } 
    else 
    {
      // set insurance Form  boolean to true to update buttons
      this.salesProfileExists = true
      console.log('New Sales Profile:', postData);
      this.http.put<any>(sales_profile_url, postData)
        .subscribe(response => {
          this.toastr.success('You added a Sales Profile Successfully.', "SUCCESS", {
                positionClass : "toast-center-center",
            });        
            this.loadData();      
        })
    }
  }


  addAddress() {
    const contact_details_url = `/api/contacts/contact_details.php?uuid=${this.contact_uuid}`;    
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '525px'; // You can use pixels or other units
    dialogConfig.height = '975px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Add Contact Address',
        modalMessage: {contact_uuid: this.contact_uuid},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
      
        this.loadData();
    });    
  }

  editAddress(params: any) {
    const contact_details_url = `/api/contacts/contact_details.php?uuid=${this.contact_uuid}`;       
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '525px'; // You can use pixels or other units
    dialogConfig.height = '975px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Edit Contact Address',
        modalMessage: {contact_uuid: this.contact_uuid,
                       contact_address_uuid: params.data.contact_address_uuid, 
                       address_type: params.data.address_type,
                       address_street: params.data.address_street,
                       address_extended: params.data.address_extended,
                       address_community: params.data.address_community,
                       address_locality: params.data.address_locality,
                       address_region: params.data.address_region,
                       address_postal_code: params.data.address_postal_code,
                       address_country: params.data.address_country,
                       address_description: params.data.address_description
        },
      },
    };
    
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });      

  }

  deleteAddress(params: any) {
    const contact_details_url = `/api/contacts/contact_details.php?uuid=${this.contact_uuid}`;       
    const dialogConfig = new MatDialogConfig();
    const contact_address_uuid = params.data.contact_address_uuid;
    const address_street = params.data.address_street;

    dialogConfig.width = '530px'; // You can use pixels or other units
    dialogConfig.height = '320px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Delete Address Confirmation',
        modalMessage: {contact_address_uuid: contact_address_uuid, address_street: address_street},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });        
  
  }

  addPhone() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '800px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Add Sub Contact',
        modalMessage: {contact_uuid: this.contact_uuid},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  editPhone(params: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '800px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Edit Sub Contact',
        modalMessage: {contact_uuid: this.contact_uuid,
                       contact_phone_uuid: params.data.contact_phone_uuid, 
                       phone_type: params.data.phone_type,
                       phone_number: params.data.phone_number,
                       phone_extension: params.data.phone_extension,
                       phone_description: params.data.phone_description,
                       contact_name: params.data.contact_name,
                       contact_name_given: params.data.contact_name_given,
                       contact_name_family: params.data.contact_name_family,
                       contact_email: params.data.contact_email
        },
      },      
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  deletePhone(params: any) {
    const dialogConfig = new MatDialogConfig();
    const contact_phone_uuid = params.data.contact_phone_uuid;
    const phone_number = params.data.phone_number;


    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '255px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Delete SubContact Confirmation',
        modalMessage: {contact_phone_uuid: contact_phone_uuid, phone_number: phone_number},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  addURL() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '515px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Add URL',
        modalMessage: {contact_uuid: this.contact_uuid},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  editURL(params: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '520px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Edit URL',
        modalMessage: {contact_uuid: this.contact_uuid,
                       contact_url_uuid: params.data.contact_url_uuid, 
                       url_type: params.data.url_type,
                       url_label: params.data.url_label,
                       url_primary: params.data.url_primary,
                       url_address: params.data.url_address,
                       url_description: params.data.url_description,
        },
      },      
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  deleteURL(params: any) {
    const dialogConfig = new MatDialogConfig();
    const contact_url_uuid = params.data.contact_url_uuid;
    const url_address = params.data.url_address;


    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '255px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Delete URL Confirmation',
        modalMessage: {contact_url_uuid: contact_url_uuid, url_address: url_address},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  addType(){
    const contact_details_url = `/api/contacts/contact_details.php?uuid=${this.contact_uuid}`;    
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '255px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Add Contact Type',
        modalMessage: {contact_uuid: this.contact_uuid},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
      
        this.loadData();
    });    
  }

  deleteType(params: any) {
    const dialogConfig = new MatDialogConfig();
    const contact_type_uuid = params.data.contact_type_uuid;
    const contact_type = params.data.contact_type;


    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '255px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Delete Contact Type Confirmation',
        modalMessage: {contact_type_uuid: contact_type_uuid, contact_type: contact_type},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  addEmail() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '415px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Add Email',
        modalMessage: {contact_uuid: this.contact_uuid},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  editEmail(params: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '420px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Edit Email',
        modalMessage: {contact_uuid: this.contact_uuid,
                       contact_email_uuid: params.data.contact_email_uuid, 
                       email_label: params.data.email_label,
                       email_address: params.data.email_address,
                       email_description: params.data.email_description,
        },
      },      
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  deleteEmail(params: any) {
    const dialogConfig = new MatDialogConfig();
    const contact_email_uuid = params.data.contact_email_uuid;
    const email_address = params.data.email_address;


    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '255px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Delete Email Confirmation',
        modalMessage: {contact_email_uuid: contact_email_uuid, email_address: email_address},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  addNote() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '255px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Add Note',
        modalMessage: {contact_uuid: this.contact_uuid},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  editNote(params: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '270px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Edit Note',
        modalMessage: {contact_uuid: this.contact_uuid,
                       contact_note_uuid: params.data.contact_note_uuid, 
                       contact_note: params.data.contact_note,
        },
      },      
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  deleteNote(params: any) {
    const dialogConfig = new MatDialogConfig();
    const contact_note_uuid = params.data.contact_note_uuid;
    const contact_note = params.data.contact_note;


    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '255px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Delete Note Confirmation',
        modalMessage: {contact_url_uuid: contact_note_uuid, contact_note: contact_note},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  addNotification() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '655px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Add Notification',
        modalMessage: {contact_uuid: this.contact_uuid,
                       contactTypeList: this.subcontact_details
        },
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  editNotification(params: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '655px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Edit Notification',
        modalMessage: {contact_uuid: this.contact_uuid,
                       contact_profile_default_notification_uuid: params.data.contact_profile_default_notification_uuid, 
                       contactTypeList: this.subcontact_details,
                       name: params.data.name, 
                       at_pick_up: params.data.at_pick_up, 
                       delayed_pick_up: params.data.delayed_pick_up, 
                       at_delivery: params.data.at_delivery, 
                       delayed_delivery: params.data.delayed_delivery, 
                       assessorials_incurred: params.data.assessorials_incurred, 
                       phone_notification: params.data.phone_notification, 
                       sms_notification: params.data.sms_notification, 
                       email_notification: params.data.email_notification, 
                       appointment_pickup: params.data.appointment_pickup, 
                       appointment_delivery: params.data.appointment_delivery, 
        },
      },      
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  deleteNotification(params: any) {
    const dialogConfig = new MatDialogConfig();
    const contact_profile_default_notification_uuid = params.data.contact_profile_default_notification_uuid;
    const name = params.data.name;


    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '255px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Delete Notification Confirmation',
        modalMessage: {contact_profile_default_notification_uuid: contact_profile_default_notification_uuid, 
                       name: name},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  addService() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '875px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Add Service',
        modalMessage: {contact_uuid: this.contact_uuid},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  editService(params: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '830px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Edit Service',
        modalMessage: {carrier_service_rate_uuid: params.data.carrier_service_rate_uuid, 
                       carrier_service: params.data.carrier_service,
                       carrier_service_type: params.data.carrier_service_type,
                       service_option: params.data.service_option,
                       currency_type: params.data.currency_type,
                       flat_rate: params.data.flat_rate,
                       service_taxed: params.data.service_taxed,
                       service_tax_multiplier: params.data.service_tax_multiplier,
                       service_tax_cost: params.data.service_tax_cost,
                       service_note: params.data.service_note
        },
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  deleteService(params: any) {
    const dialogConfig = new MatDialogConfig();
    const carrier_service_rate_uuid = params.data.carrier_service_rate_uuid;
    const carrier_service = params.data.carrier_service;
    const carrier_service_type = params.data.carrier_service_type;

    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '340px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Delete Service Confirmation',
        modalMessage: {carrier_service_rate_uuid: carrier_service_rate_uuid, carrier_service: carrier_service, carrier_service_type: carrier_service_type},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  addDefaultService() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '340px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Add Default Service',
        modalMessage: {contact_uuid: this.contact_uuid},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  editDefaultService(params: any) {
    const dialogConfig = new MatDialogConfig();
    const contact_profile_default_service_uuid = params.data.contact_profile_default_service_uuid;
    const service = params.data.service;
    const service_type = params.data.service_type;    
    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '340px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Edit Default Service',
        modalMessage: {contact_profile_default_service_uuid: contact_profile_default_service_uuid, 
                       service: service, 
                       service_type: service_type},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  deleteDefaultService(params: any) {
    const dialogConfig = new MatDialogConfig();
    const contact_profile_default_service_uuid = params.data.contact_profile_default_service_uuid;
    const service = params.data.service;
    const service_type = params.data.service_type;

    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '340px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Delete Default Service Confirmation',
        modalMessage: {contact_profile_default_service_uuid: contact_profile_default_service_uuid, service: service, service_type: service_type},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }


  deleteDocument(document: ContactDocumentInfo) {
    const dialogConfig = new MatDialogConfig();
    const contact_document_uuid = document.contact_document_uuid;
    const file_name = document.file_name;

    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '255px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Delete Contact Document Confirmation',
        modalMessage: {contact_document_uuid: contact_document_uuid, file_name: file_name},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe(result => {
        this.loadData();
    });     
  }

  // Document handling
  handleDocumentDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDraggingOverDocument = true;
  }

  handleDocumentDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDraggingOverDocument = false;
  }

  handleDocumentDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDraggingOverDocument = false;

    if (event.dataTransfer?.files.length && this.contact_uuid) {
      const documentFormData = new FormData();
      for (let i = 0; i < event.dataTransfer.files.length; i++) {
        documentFormData.append(
          'file',
          event.dataTransfer.files[i],
          event.dataTransfer.files[i].name
        );
      }

      // 👇 Append contact uuid
      documentFormData.append('contact_uuid', this.contact_uuid);

      this.openDocumentTypeDialog(documentFormData);
    }
  }

  private openDocumentTypeDialog(documentFormData: FormData): void {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '348px'; // You can use pixels or other units
    dialogConfig.height = '340px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Upload Contact Document',
        modalMessage: {documentFormData},
      },
    };
    const DialogRef = this.dialog.open(ContactModalComponent, dialogConfig);
    DialogRef.afterClosed().subscribe((result) => {
      if (result) {
        documentFormData.append('document_type', result.document_type);
        documentFormData.append('file_description', result.file_description);
        this.uploadDocument(documentFormData);
      }
    });    

  }

  private uploadDocument(documentFormData: FormData): void {
    console.log('Upload FormData', documentFormData);
    this.http.post('api/documents/contact_document_upload.php', documentFormData).subscribe({
      next: (response: any) => {
        console.log('Response', response);
        if (response.success) {
          console.log('SUCCESSFUL');
          this.toastr.success('File uploaded.', "SUCCESS", {
                positionClass : "toast-center-center",
            });                   
          this.loadData();
        } else {
          console.log('FAILED Upload');
          this.toastr.error('File upload failed: ${response.message}', "FAILED", {
                positionClass : "toast-center-center",
            });               
          this.toastr.error(`File upload failed: ${response.message}`);
        }
      },
      error: (error) => {
        console.error('Upload error:', error);
          this.toastr.error('Error uploading file.', "FAILED", {
                positionClass : "toast-center-center",
            });             
        this.toastr.error('Error uploading file.');
      },
    });    
  }


async openDocument(document: ContactDocumentInfo): Promise<void> {
  try {
    const documentUrl = `/api/work_orders/document_content.php?document_uuid=${document.contact_document_uuid}&file_name=${document.file_name}&file_format=${document.file_format}&type=contact`;
    console.log('Open URL', documentUrl)
    const response = await this.http.get<any>(documentUrl).toPromise();
    console.log('Open Response', response)
    const base64 = response;
    let mimeType = 'application/pdf';
    if (['png', 'jpg', 'jpeg', 'tif'].includes(document.file_format)) {
      mimeType = `image/${document.file_format}`;
    }

    const fileUrl = await this.createFileURLFromBase64(base64, mimeType);    

    if (fileUrl) {
      const format = document.file_format.toLowerCase();

      // PDF: open in new tab
      if (format === 'pdf') {
        window.open(fileUrl, '_blank');
        return;
      }

      // doc: open in new tab
      if (format === 'doc') {
        window.open(fileUrl, '_blank');
        return;
      }

      // TIFF/TIF: force download
      if (format === 'tif' || format === 'tiff') {
        const a = window.document.createElement('a');
        a.href = fileUrl;
        a.download = document.file_name;
        a.click();
        URL.revokeObjectURL(fileUrl);
        return;
      }

      // Everything else = image → open modal
      this.dialog.open(DocumentModalComponent, { 
        width: '90vw', 
        data: { 
          fileURL: fileUrl,
          isImage: true,
          type: 'document'   // ensures modal says “Document”
        }
      });
    }

  } catch (error) {
    console.error('Error opening document:', error);
    this.toastr.success('Could not open document.', "FAILED", {
          positionClass : "toast-center-center",
      });     
  }
}

  private createFileURLFromBase64(base64: string, mimeType: string): string {
    const byteArray = new Uint8Array(window.atob(base64).split("").map(char => char.charCodeAt(0)));
    const file = new Blob([byteArray], { type: mimeType });
    return URL.createObjectURL(file);
  }

  refresh(params: any): boolean {
    return false;
  }

}
